module.exports = "<div class=\"msg\">\n  <p><%= content %></p>\n</div>";
